import VariablesTable from '../../features/variable/VariablesTable';

const VariablePage = () => (
    <div className="max-w-screen overflow-x-auto whitespace-nowrap">
      <VariablesTable />
    </div>
  );

export default VariablePage;
